<div *ngIf="loading" style="position: absolute; top: 0; left: 0; background-color: rgba(0,0,0,0.4); height: 100%; width: 100%; z-index: 1;">
    <div class="loader is-active" style="margin-top: 25%;">
        <div class="loader-bars"></div>
    </div>
</div>

<nav class="tab-nav">
    <a class="tab-title"
       [ngClass]="{ 'is-active': currentTabIndex === 0 }"
       (click)="activateTab(0)">Basic Query</a>
    <a [hidden] ="!showGeographicFilter || !enableGeographicFilter" class="tab-title"
       [ngClass]="{ 'is-active': currentTabIndex === 1 }"
       (click)="activateTab(1)">Geographic</a>
    <a [hidden] ="!showJoinFilter || !enableJoinFilter" class="tab-title" 
       [ngClass]="{ 'is-active': currentTabIndex === 2 }"
       (click)="activateTab(2)">Join</a>
    <a [hidden] ="!showChildRecordFilter || !enableChildRecordFilter" class="tab-title"
       [ngClass]="{ 'is-active': currentTabIndex === 3 }"
       (click)="activateTab(3)">Child Records</a>

</nav>
<section class="tab-contents">
    <article class="tab-section" name="Basic Query"
             [ngClass]="{ 'is-active': currentTabIndex === 0 }">
        <mc-basic-filter-ng #basicFilter id="basicFilter" [updateLayerOnApply]="false"></mc-basic-filter-ng>
    </article>
    <article [hidden] ="!showGeographicFilter || !enableGeographicFilter" class="tab-section" name="Geographic"
             [ngClass]="{ 'is-active': currentTabIndex === 1 }">
        <mc-geographic-filter-ng #geographicFilter id="geographicFilter" [updateLayerOnApply]="false" [mapView]="mapView"></mc-geographic-filter-ng>
    </article>
    <article [hidden] ="!showJoinFilter || !enableJoinFilter" class="tab-section" name="Join"
             [ngClass]="{ 'is-active': currentTabIndex === 2 }">
        <mc-join-filter-ng #joinFilter id="joinFilter" [updateLayerOnApply]="false"></mc-join-filter-ng>
    </article>
    <article [hidden] ="!showChildRecordFilter || !enableChildRecordFilter" class="tab-section" name="Child Records"
             [ngClass]="{ 'is-active': currentTabIndex === 3 }">
        <mc-child-records-filter-ng #childRecordsFilter id="childRecordsFilter" [updateLayerOnApply]="false"></mc-child-records-filter-ng>
    </article>
</section>

